module.exports = __webpack_public_path__ + "static/slachova-2b86a5d2595ad60cdc5fe6257fcea01c.jpg";